export const ESA_APPROVED_TAG_PREFIX = "esa_approved_";
